module.exports = __webpack_public_path__ + "img/note.b253d726.png";